/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import DescriptionIcon from '@material-ui/icons/Description';
import LanguageIcon from '@material-ui/icons/Language';
import EventNoteIcon from '@material-ui/icons/EventNote'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined'
import ScheduleIcon from '@material-ui/icons/Schedule'
import ContactPhoneIcon from '@material-ui/icons/ContactPhone'
import NotificationsIcon from '@material-ui/icons/Notifications'
import AssignmentIcon from '@material-ui/icons/Assignment'
import HeadsetIcon from '@material-ui/icons/Headset'
import MapIcon from '@material-ui/icons/Map'
import PeopleIcon from '@material-ui/icons/People'
import { shallowEqual, useSelector } from 'react-redux'

export function AsideMenuList({ layoutProps }) {
	const user = useSelector((store) => store.authentication?.user, shallowEqual)
	const location = useLocation()
	const getMenuItemActive = (url, hasSubmenu = false) => {
		return checkIsActive(location, url)
			? ` ${!hasSubmenu &&
          'menu-item-active'} menu-item-open menu-item-not-hightlighted`
			: ''
	}

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				<li
					className={`menu-item ${getMenuItemActive('/dashboard', false)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/dashboard">
						<span className="svg-icon menu-icon">
							<SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')} />
						</span>
						<span className="menu-text">Dashboard</span>
					</NavLink>
				</li>
				<li className="menu-section">
					<h4 className="menu-text">USERS</h4>
					<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
				</li>
				{user.role === 'admin' && <li
					className={`menu-item ${getMenuItemActive('/admins', false)} ${getMenuItemActive('/edit-admin', false)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/admins">
						<span className="menu-icon">
							<AssignmentIndIcon/>
						</span>
						<span className="menu-text">Administrators</span>
					</NavLink>
				</li>}
				{user.role === 'admin' && <li
					className={`menu-item ${getMenuItemActive('/users', false)} ${getMenuItemActive('/edit-user', false)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/users">
						<span className="menu-icon">
							<PeopleIcon/>
						</span>
						<span className="menu-text">Usuarios</span>
					</NavLink>
				</li>}

				{user.role === 'admin' && (
					<>
						<li className='menu-section'>
							<h4 className='menu-text'>GESTIÓN CÍVICA</h4>
							<i className='menu-icon ki ki-bold-more-hor icon-md'></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/citas', false)} ${getMenuItemActive('/edit-cita', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/citas'>
								<span className='menu-icon'>
									<EventNoteIcon />
								</span>
								<span className='menu-text'>Citas previas</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/incidencias', false)} ${getMenuItemActive('/edit-incidencia', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/incidencias'>
								<span className='menu-icon'>
									<ReportProblemIcon />
								</span>
								<span className='menu-text'>Incidencias</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/sugerencias', false)} ${getMenuItemActive('/edit-sugerencia', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/sugerencias'>
								<span className='menu-icon'>
									<EmojiObjectsOutlinedIcon />
								</span>
								<span className='menu-text'>Buzón de sugerencias</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/departments', false)} ${getMenuItemActive('/edit-department', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/departments'>
								<span className='menu-icon'>
									<ScheduleIcon />
								</span>
								<span className='menu-text'>Horarios de servicios</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/push', false)} ${getMenuItemActive('/edit-push', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/push'>
								<span className='menu-icon'>
									<NotificationsIcon />
								</span>
								<span className='menu-text'>Notificaciones push</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/forms', false)} ${getMenuItemActive('/edit-form', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/forms'>
								<span className='menu-icon'>
									<AssignmentIcon />
								</span>
								<span className='menu-text'>Formularios</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/gamification-audioguides', false)} ${getMenuItemActive('/edit-gamification-audioguide', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/gamification-audioguides'>
								<span className='menu-icon'>
									<HeadsetIcon />
								</span>
								<span className='menu-text'>Gamificación y Audioguías</span>
							</NavLink>
						</li>
					</>
				)}

				<li className='menu-section'>
					<h4 className='menu-text'>MISCELLANY</h4>
					<i className='menu-icon ki ki-bold-more-hor icon-md'></i>
				</li>
				{user.role === 'admin' && (
					<>
						<li
							className={`menu-item ${getMenuItemActive('/contact', false)} ${getMenuItemActive('/edit-contact', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/contact'>
								<span className='menu-icon'>
									<ContactPhoneIcon />
								</span>
								<span className='menu-text'>Contacto</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/s11-maps', false)} ${getMenuItemActive('/edit-s11-map', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/s11-maps'>
								<span className='menu-icon'>
									<MapIcon />
								</span>
								<span className='menu-text'>Mapas S11</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/languages',
								false
							)} ${getMenuItemActive('/edit-language', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/languages'>
								<span className='menu-icon'>
									<LanguageIcon />
								</span>
								<span className='menu-text'>Languages</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive('/texts', false)} ${getMenuItemActive('/edit-text', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/texts">
								<span className="menu-icon">
									<DescriptionIcon/>
								</span>
								<span className="menu-text">Texts</span>
							</NavLink>
						</li>
					</>
				)}
			</ul>

			{/* end::Menu Nav */}
		</>
	)
}
